import { getDeviceDetailData } from '@/api/device';
import { addSubDevice, getDevice, deleteSubDevice } from '@/api/devices';
import { getProductList } from '@/api/product';
import CommonLayout, { CommonLayoutInstance } from '@/components/CommonLayout';
import { Badge, Form, Input, Select, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import React, { Fragment, useEffect, useRef, useState } from 'react';

const { Text } = Typography;
const Tab4 = ({ id }: { id: string }) => {
  const CommonLayoutRef = useRef<CommonLayoutInstance<{ params: {}; model: {}; drawerParams: {}; drawerModel: {} }>>(null);

  const [productList, setProductList] = useState<{ name: string; id: string }[]>([]);
  const getList = async () => {
    const res = await getProductList({ isAll: true });
    setProductList(res.result.list?.map((item) => ({ name: item.name, id: item.id })) || []);
    // console.log({ res });
  };
  const [deviceList, setDeviceList] = useState<{ name: string; id: string }[]>([]);

  const getDeviceList = async (product_id: string) => {
    try {
      const res = await getDevice({ isAll: true, product_id });
      setDeviceList(res.result.list?.map((item) => ({ name: item.name, id: item.id })) || []);
    } catch {}
  };
  useEffect(() => {
    getList();
  }, []);
  return (
    <CommonLayout
      ref={CommonLayoutRef}
      isHideBreadcrumb
      isHideCardCls
      breadcrumb={{
        title: '',
        describe: '',
      }}
      ajaxJson={{
        get: {
          // @ts-ignore
          ajax: getDevice,
          params: { parent_id: id },
        },
        delete: {
          // @ts-ignore
          ajax: deleteSubDevice,
          operateName: '删除',
        },
      }}
      commonCbk={(key) => {
        if (key !== 'get') {
          CommonLayoutRef.current?.reload();
        }
      }}
      searchFormChildren={
        <Space style={{ marginLeft: '16px' }}>
          <Form.Item name="name">
            <Input placeholder="设备名称" allowClear></Input>
          </Form.Item>
        </Space>
      }
      isHideOperateDetailButton
      searchFormLeftOperateButtonList={[
        {
          name: '新增',
          ajaxKey: 'add',
          props: { type: 'primary' },
          isToShowDrawer: true,
          drawerProps: { title: '新增' },
          // sortData: () => ({ device_id: id }),
        },
      ]}
      columns={[
        { title: '设备ID', key: 'id', dataIndex: 'id', fixed: 'left' },
        { title: '设备名称', key: 'name', dataIndex: 'name', fixed: 'left' },
        { title: '所属产品', key: 'product_name', dataIndex: 'product_name' },
        {
          title: '设备状态',
          key: 'status',
          dataIndex: 'status',
          // @ts-ignore
          render: (value, record: { status: string }) => {
            return (
              <>
                <Badge
                  color={
                    {
                      在线: 'green',
                      离线: 'gray',
                      禁用: 'red',
                      未激活: 'orange',
                    }[record.status] || 'gray'
                  }
                />
                <Text className="ml5">{value || '未知'}</Text>
              </>
            );
          },
        },
        { title: '平台', key: 'platform', dataIndex: 'platform' },
        { title: '关联驱动', key: 'driver_service_name', dataIndex: 'driver_service_name' },
        {
          title: '创建时间',
          key: 'created',
          dataIndex: 'created',
          render(value) {
            return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
          },
        },
        {
          title: '最近在线时间',
          key: 'last_online_time',
          dataIndex: 'last_online_time',
          render(value) {
            return value === 0 ? '-' : dayjs(value).format('YYYY-MM-DD HH:mm:ss');
          },
        },
      ]}
      operateButtonList={[
        {
          name: '查看',
          props: { type: 'primary' },
          ajaxKey: 'detail',
          isToPath: true,
          sortPathParams: (record) => ({ pathname: `/gateway/device/detail/${record.id}` }),
          onClick: () => {
            location.reload();
          },
        },
        {
          name: '删除',
          ajaxKey: 'delete',
          props: { type: 'primary', danger: true },
          isToPopConfirm: true,
          isToAjax: true,
          popconfirmProps: { title: '是否确认删除该设备?' },
          isToReload: true,
          sortData: (record) => ({ device_id: id, child_device_id: [record.id] }),
        },
      ]}
      drawerJson={{
        ajaxJson: {
          add: {
            // @ts-ignore
            ajax: addSubDevice,
            convertValue: (values) => ({ ...values, device_id: id }),
            operateName: '新增',
          },
          get: {
            // @ts-ignore
            ajax: getDeviceDetailData,
            convertValue: ({ id }) => ({ id }),
            transform: ({ id, product_id }) => {
              getDeviceList(product_id);
              return { product_id, child_device_id: id };
            },
          },
        },
        commonCbk: (key) => {
          if (key !== 'get') {
            CommonLayoutRef.current?.reload();
          }
        },
        formProps: {
          onValuesChange: (changedValues) => {
            const [key, value] = Object.entries(changedValues)[0];
            if (key === 'product_id') {
              getDeviceList(value as string);
            }
          },
        },
        renderFormChildren: ({ ajaxKey, isDetail: disabled }) => {
          return (
            <Fragment key={ajaxKey || 'edit'}>
              <Form.Item name="product_id" label="产品" rules={[{ required: true }]}>
                <Select placeholder="请选择" options={productList} fieldNames={{ label: 'name', value: 'id' }} disabled={disabled}></Select>
              </Form.Item>
              <Form.Item name="child_device_id" label="设备" rules={[{ required: true }]}>
                <Select placeholder="请选择" disabled={disabled} options={deviceList} fieldNames={{ label: 'name', value: 'id' }}></Select>
              </Form.Item>
            </Fragment>
          );
        },
      }}
      searchFormRightOperateButtonList={[
        {
          name: '删除',
          ajaxKey: 'delete1',
          // isToPopConfirm: true,
          props: { type: 'primary', danger: true, disabled: true },
          // popconfirmProps: { disabled: true, title: '是否确认删除选中日志' },
          filter: (data) => !!data?.length,
        },
        {
          name: '删除',
          ajaxKey: 'delete',
          sortData: (ids) => ({ device_id: id, child_device_id: ids }),
          isToPopConfirm: true,
          isToAjax: true,
          props: { type: 'primary', danger: true },
          popconfirmProps: { title: '是否确认删除设备' },
          filter: (data) => !data?.length,
        },
      ]}
      hasRowSelection
    ></CommonLayout>
  );
};

export default Tab4;
